import { render, staticRenderFns } from "./LocalsGroupCreationModal.vue?vue&type=template&id=68b39d50&scoped=true"
import script from "./LocalsGroupCreationModal.vue?vue&type=script&lang=js"
export * from "./LocalsGroupCreationModal.vue?vue&type=script&lang=js"
import style0 from "./LocalsGroupCreationModal.vue?vue&type=style&index=0&id=68b39d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b39d50",
  null
  
)

export default component.exports